module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-daisy-pink-6e6d6590067970eb8b1d5e14f1e64ae2.svg";